<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-dialog v-model="dialogaddprodukmember" persistent max-width="500">
      <v-card>
        <v-card-title class="primary white--text">Tambah Produk</v-card-title>
        <v-card-text>
          <v-form lazy-validation class="mt-4">
            <div class="mt-6">
              <v-autocomplete
                  label="Categori "
                  item-text="name"
                  item-value="id"
                  @change="getnBrandsByid(newdata.categoryid)"
                  v-model="newdata.categoryid"
                  :items="category">
              </v-autocomplete>
            </div>
              <v-autocomplete
                  label="Brand/Operator"
                  item-text="brandname"
                  item-value="id"
                  v-model="newdata.brandid"
                  @change="getnProductByBrandId(newdata.brandid)"
                  :items="nbrands">
              </v-autocomplete>
            <v-select
                label="Produk"
                item-text="productname"
                item-value="id"
                return-object
                v-model="newdata.product"
                :items="nproduct">
            </v-select>
              <v-container>
                <v-row>
                  <v-text-field class="mr-2" v-model="newdata.product.productcode" readonly label="Kode Market"></v-text-field>
                  <v-text-field v-model="newdata.kodesupplier" label="Kode Supplier"></v-text-field>
                </v-row>
              </v-container>
            <v-container>
              <v-row>
                <v-text-field v-model="newdata.buyprice" type="number" label="Harga Beli"></v-text-field>
                <v-text-field v-model="newdata.sellprice" type="number" label="Harga Jual"></v-text-field>
                <v-text-field v-model="newdata.promoprice" type="number" label="Harga Promo"></v-text-field>
                <v-text-field v-model="newdata.stok" type="number" label="Stok (Optional)"></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="setdialogproductmember(false)" dark class="red">Tutup</v-btn>
          <v-btn text dark  @click="simpantambah" class="primary">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="primary white--text">Edit Produk</v-card-title>
        <v-card-text>
            <v-form lazy-validation class="mt-4">
              <v-text-field readonly label="Produk" v-model="editproduk.productcode"></v-text-field>
              <v-text-field readonly label="Produk" v-model="editproduk.productname"></v-text-field>
              <v-text-field class="" label="Kode Suplier" v-model="editproduk.membercode"></v-text-field>
              <v-container>
              <v-row class="">
                <v-text-field class="" autofocus type="number" label="Harga Jual" v-model="editproduk.sellprice"></v-text-field>
                <v-text-field class="" type="number" label="Harga Diskon" v-model="editproduk.discount"></v-text-field>
              </v-row>
              </v-container>
              <v-text-field v-model="editproduk.stok" type="number" label="Stok (Optional)"></v-text-field>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="setdialog(false)" dark class="red">Tutup</v-btn>
          <v-btn text dark @click="updateProductSeller(editproduk)" class="primary">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          outlined
          dense
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitable.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer/>
      <div class="mt-5 mr-2">
        <v-autocomplete
            clearable
            label="Category"
            @change="getProductSeller(opsitable)"
            item-text="name"
            item-value="id"
            v-model="opsitable.categoryid"
            :items="category"
        ></v-autocomplete>
      </div>
      <div class="mt-5 mr-2">
        <v-autocomplete
            clearable
            label="Brand"
            @change="getProductSeller(opsitable)"
            item-text="brandname"
            item-value="id"
            v-model="opsitable.brandid"
            :items="brands"
        ></v-autocomplete>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getProductSeller(opsitable)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="opennew">
        <v-icon dark>add</v-icon>Tambah
      </v-btn>
      <v-btn small dark elevation="0" class="ml-2" color="blue" @click.native="doSyncHarga">
        <v-icon dark>refresh</v-icon>Sync Harga
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        dense
        :headers="headers"
        :search="opsitable.search"
        :items="productseller"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitable"
        :server-items-length="totalproductseller"
        :loading="loading"
        @update:options="getProductSeller(opsitable)">

      <template v-slot:item.sellprice="{ item }">
        <div  class="text-right">
          {{formatAngka(item.sellprice)}}
        </div>
      </template>
      <template v-slot:item.discount="{ item }">
        <div  class="text-right">
          {{formatAngka(item.discount)}}
        </div>
      </template>
      <template v-slot:item.stok="{ item }">
        <div  class="text-right">
          {{formatAngka(item.stok)}}
        </div>
      </template>
      <template v-slot:item.statustoko="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.statustoko)"
              small
              text-color="white">
            {{ tokostatustext(item.statustoko) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.sellername="{ item }">
        <div @click="gosellerpage(item.sellerid)" style="cursor: pointer;">{{item.sellername}}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
        <v-btn @click="openedit(item)" fab x-small text dark class="blue"><v-icon>edit</v-icon></v-btn>
        <v-btn v-if="item.status===1"  x-small dark fab text @click.native="nonaktifkanmapping(item)" class="red ml-2">
          <v-icon small>close</v-icon>
        </v-btn>
        <v-btn v-else x-small dark fab text @click.native="aktifkanmapping(item)" class="primary ml-2">
          <v-icon small>done</v-icon>
        </v-btn>
        <v-btn x-small dark fab text @click.native="hapus(item)" class="red ml-2">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import moment from 'moment'

export default {
  name: 'ProductJual',
  data: () => ({
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      paymentstatus: '',
      sortBy: ['id']
    },
    newdata: {
      categoryid: 0,
      brandid: 0,
      productid: 0,
      kodesupplier: '',
      product: {},
      sellprice: 0,
      buyprice: 0,
      promoprice: 0,
      stok: 0
    },
    editproduk: {},
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Brand',
        value: 'brandname'
      },
      {
        text: 'Kode',
        value: 'productcode',
        groupable: false
      },
      {
        text: 'Produk',
        value: 'productname',
        groupable: false
      },
      {
        text: 'Kode Local',
        value: 'membercode',
        groupable: false
      },
      {
        text: 'Harga Jual',
        value: 'sellprice',
        align: 'right',
        groupable: false
      },
      {
        text: 'Harga Promo',
        value: 'discount',
        align: 'right',
        groupable: false
      },
      {
        text: 'Stok ',
        value: 'stok',
        groupable: false
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Aksi',
        value: 'aksi',
        groupable: false
      }
    ]
  }),
  mounted () {
    this.getBrands()
  },
  computed: {
    ...mapState('ProductStore', ['category', 'brands']),
    ...mapState('SellerStore', ['productseller', 'nbrands', 'nproduct', 'totalproductseller', 'loading', 'dialog', 'dialogaddprodukmember'])
  },
  methods: {
    ...mapActions('ProductStore', ['getBrands']),
    ...mapActions('SellerStore', ['getnBrandsByid', 'addProductSeller', 'getnProductByBrandId', 'getProductSeller', 'updateProductSeller', 'setdialogproductmember', 'setdialog', 'deleteProductSeller', 'doSyncHarga']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    opennew () {
      this.newdata = {
        categoryid: 0,
        brandid: 0,
        productid: 0,
        kodesupplier: '',
        product: {},
        sellprice: 0,
        buyprice: 0,
        promoprice: 0,
        stok: 0
      }
      this.setdialogproductmember(true)
    },
    openedit (item) {
      this.editproduk = item
      this.setdialog(true)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    colorStatus (val) {
      if (parseInt(val) === 1) {
        return 'green'
      } else {
        return 'red'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Buka'
      } else {
        return 'Tutup'
      }
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Aktif'
      } else {
        return 'Non Aktif'
      }
    },
    simpantambah () {
      this.newdata.productid = this.newdata.product.id
      this.addProductSeller(this.newdata)
    },
    hapus (val) {
      this.$confirm('Yakin akan Hapus ' + val.productname, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.deleteProductSeller(val.id)
        }
      })
    },
    aktifkanmapping (val) {
      this.$confirm('Yakin akan Aktifkan ' + val.productname, { color: 'green', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          const a = val
          a.status = 1
          this.updateProductSeller(a)
        }
      })
    },
    nonaktifkanmapping (val) {
      this.$confirm('Yakin akan NonAktifkan ' + val.productname, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          const a = val
          a.status = 0
          this.updateProductSeller(a)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
